export default {"src":"/statics/ecommerce/_next/static/media/logo_B.ad6d1d91.svg","height":124,"width":110,"blurWidth":0,"blurHeight":0};